export default __webpack_public_path__ + "static/media/today_calendar.ec275786.svg";